/**
 * The Publish dialog's line on which services are deployed (Apps › Deploy this service, utils/deployFlags.js), from
 * vfs-service's `GET /publish/check` › `deploy`: "2 of 3 services will be deployed (design-mockup is off)", with "Change
 * in Apps". Console, the image registry and GitOps deploy only those; Git and Download carry every service's code.
 * The release gate counts the deployed services only, except for Git and GitOps: their secrets and licences checks count
 * every service (the code goes to the Git remote whatever the switch; vfs-service quality/view.js gate.git), and the
 * note says so, with whether that blocks them (`gate`, GET /quality/gate's answer).
 * Nothing on an older sandbox (no `deploy` in the answer), or in a project of one service that is deployed.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { deploySentence } from '../utils/deployFlags';

/** The services that are deployed, of the check's answer (every service on an older sandbox). */
export const deployedServices = (check) => (check?.services || []).filter((name) => !(check?.deploy?.off || []).includes(name));

export default function PublishDeployNote({ check, gate = null, onOpenApps = null }) {
  const deploy = check?.deploy;
  if (!deploy || (!deploy.off?.length && (check.services || []).length < 2)) { return null; }
  const sentence = deploy.sentence || deploySentence(check.services, deploy.off);
  return (
    <p className="publish-note" data-testid="publish-deploy-note">
      {sentence}.
      {deploy.off?.length > 0 && ' Git and Download still include every service\'s code.'}
      {deploy.off?.length > 0 && (
        <span data-testid="publish-deploy-gate">
          {' '}Quality counts only the deployed services, except that for Git and GitOps secrets and licences are checked in every service.
          {gate?.git?.blocked && ' That blocks Git and GitOps now.'}
        </span>
      )}
      {onOpenApps && <> <button className="publish-text-btn" data-testid="publish-deploy-change" onClick={() => onOpenApps(deploy.off?.[0] || null)} type="button">Change in Apps</button></>}
    </p>
  );
}

PublishDeployNote.propTypes = {
  // GET /publish/check: `{ services, deploy: { off, sentence } }`.
  check: PropTypes.object,
  // GET /quality/gate's gate: `git` (secrets and licences in every service) says whether Git and GitOps are blocked.
  gate: PropTypes.object,
  // (service) => opens Apps on that service (its Deploy switch); none: no link.
  onOpenApps: PropTypes.func,
};
